<ng-container *ngIf="isPopup; else noPopup">
  <sub-header [isModal]="true" [windowHash]="windowHash"></sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
    <ng-container *ngTemplateOutlet="noPopup"></ng-container>
  </p-scrollPanel>
</ng-container>

<ng-template #noPopup>
  <div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="loaded">
    <div class="container-fluid  p-0">
      <!-- COMENTARIO DE RECHAZO -->
      <rejectionPanel [document]="documento"></rejectionPanel>
      <div class="row"  *ngIf="!hideDocumentPanel">
        <!-- SI ES UN DOCUMENTO MANUAL (SIN TAREA) HAY QUE SELECCIONAR TIPO DE DOCUMENTO, DIVISION Y FASE -->
        <ng-container *ngIf="task === undefined">
          <div class="col-12">
            <formElement [model]="documento" [fieldConfig]="getBuscadorTipoDocumentosConfig()"
              (valueChanged)="newDocument (true, $event)" [enabled]="documentClassEditable"></formElement>
          </div>
          <div class="col-12">
            <formElement [model]="documento" [fieldConfig]="getBuscadorDivisionTree()"
              (valueChanged)="newDocument (false)">
            </formElement>
          </div>
          <div class="col-12">
            <formElement [model]="this" [fieldConfig]="getBuscadorFaseConfig()"></formElement>
          </div>
        </ng-container>
        <!-- DATOS GENERALES DEL DOCUMENTO -->
        <ng-container>
          <div class="col-6">
            <label>{{ 'BasicDocument.description' | translate }}</label>
            <input type="text" [(ngModel)]="documento.name" name="workName"
              class="plForm-element EDITABLE p-inputtext form-control" tabindex="1" id="focus" maxlength="200" />
          </div>
          <div class="col-2">
            <label>{{ 'BasicDocument.fecha' | translate }}</label>
            <div class="input-group date">
              <p-calendar [(ngModel)]="documento.effectiveDate" name="workCreationDate" [showIcon]="true"
                [dateFormat]="PRIMENG_DATE_FORMAT" tabindex="2" [firstDayOfWeek]=1></p-calendar>
            </div>
          </div>
          <div class="col-2"
            *ngIf="this.documento?.confidentialityLevel && this.documento?.confidentialityLevel !== 'NotRestricted'">
            <label>{{ 'DocumentView.confidentialityLevel' | translate }}</label>

            <p-dropdown id="selConfLevel" [options]="possibleConfidentialityLevels"
              [disabled]="!this.enableChangeConfLevel" [ngModel]="this.documento.confidentialityLevel"></p-dropdown>

          </div>
          <div class="col-2"
            *ngIf="localeSet() || localeToBeSet()">
            <label>{{ 'Languages.language' | translate }}</label>
            <!-- Si definimos el idioma en el documento lo forzamos y no sacamos combo -->
            <div style="padding: em 1em"
              *ngIf="localeSet()">
              <img style="vertical-align: middle; margin-right: .5em" src="assets/img/{{desiredLocale}}.gif"
                height="20px" />
              <span>{{ ('Languages.' + desiredLocale) | translate}}</span>
            </div>
            <!-- Si no lo definimos permitimos seleccionarlo -->
            <div style="padding: em 1em" *ngIf="localeToBeSet()">
              <p-dropdown id="selLocales" [options]="possibleLocales" [(ngModel)]="selectedLocale"></p-dropdown>
            </div>
          </div>

          <div class="col-6 mt-2" *ngIf="this.completeDocument">
            <p-checkbox name="completeDocumento" label="{{ 'BasicDocument.completeDocument' | translate }}" tabindex="3"
              [(ngModel)]="documento.markedAsCompleted" binary="true" (onChange)="changeCompletedMark($event.checked)">
            </p-checkbox>
          </div>
          <div class="col-12 mt-2">
            <label>{{ 'BasicDocument.comments' | translate }}</label>
            <textarea maxlength="600" class="form-control"
              placeholder="{{ 'BasicDocument.write.comments' | translate }}" tabindex="4"
              [(ngModel)]="documento.comment" name="workComment"></textarea>
          </div>
        </ng-container>
      </div>
      <ng-container *ngTemplateOutlet="PERSONALIZABLES"></ng-container>
      <!-- BOTONERA DE PLANTILLAS Y ADJUNTOS -->
      <div class="row" *ngIf="!gestionarSinAdjuntos()">
        <div class="titleElement mt-2 mb-2"> {{ 'BasicDocument.documentFiles' | translate }} </div>
        <!--div class="mt-2 mb-2">

          <button class="btn btn-secondary" (click)="openSelectorTemplate()" tabindex="6" type="button" appNoDblClick>
            <i aria-hidden="true" class="fa fa-file-text" aria-hidden="true"></i><span class="d-none d-sm-inline">
              {{ 'BasicDocument.generate.from.template' | translate }}</span>
          </button>
        </div-->
        <!-- ZONA DE  ADJUNTOS -->
        <div class="col-12">
          <upload-files [files]="drafFiles" [documentClass]="documento.entity.documentClass"
            (deleteItem)="deleteFileItem($event)" (addItem)="addFileItem($event)" (modifyItem)="modifyFileItem($event)"
            tabindex="7"
            *ngIf="this.documento.entity.division&&this.documento.entity.documentClass&&this.documento.entity.documentClass.configuration&&this.selectedPhase">
          </upload-files>
        </div>
        <div class="col-12">
          <span class="alert alert-info d-block"
            *ngIf="!(this.documento.entity.division&&this.documento.entity.documentClass&&this.documento.entity.documentClass.configuration&&this.selectedPhase)">
            <i class="fas fa-lg fa-info-circle mr-2" aria-hidden="true"></i> {{ 'BasicDocument.files.message' |
            translate
            }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- CAMPOS PERSONALIZABLES -->
<ng-template #PERSONALIZABLES>
  <div class="row" *ngIf="customFieldsDef && customFieldsDef.length > 0">
    <div class="titleElement mt-2 mb-2">{{ getCustomFieldTitle() | translate }}</div>
    <div class="col-12">
      <ng-container *ngFor="let cfd of sortedCustomFields()">
        <formElement [model]="documento.customFields" [fieldConfig]="cfd"></formElement>
      </ng-container>
    </div>
  </div>
</ng-template>